<template>
<!-- 
The header sensitivity was on the `a` element. We put it on the `card-header` div.

Changes:
- Renamed component `collapse-item-card`
- Removed `<i class="tim-icons icon-minimal-down"></i>`
- Added styles to the `after` pseudo-element 
- Changed default value of `active` from false to true
- Added activeDefault prop
- Added `change` event
- Added `visible` and `showDefault` data
-->

  <div class="card" v-show="visible">
    <div role="tab" class="card-header" :aria-expanded="active">
      <slot name="title"> {{ title }} </slot>
      <div class="clickable" @click.prevent="activate">
      </div>
    </div>
    <collapse-transition :duration="animationDuration">
      <div
        v-show="active"
        :id="`content-${itemId}`"
        role="tabpanel"
        :aria-labelledby="title"
        class="collapsed"
      >
        <div class="card-body"><slot></slot></div>
      </div>
    </collapse-transition>
  </div>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions';

export default {
  name: 'collapse-item-card',
  components: {
    CollapseTransition
  },
  props: {
    title: {
      type: String,
      default: '',
      description: 'Collapse item title'
    },
    activeDefault: {
      type: Boolean,
      default: true,
    },
    showDefault: {
      type: Boolean,
      default: true,
    },
    id: String
  },
  inject: {
    animationDuration: {
      default: 250
    },
    multipleActive: {
      default: false
    },
    addItem: {
      default: () => {}
    },
    removeItem: {
      default: () => {}
    },
    deactivateAll: {
      default: () => {}
    }
  },
  computed: {
    itemId() {
      return this.id || this.title;
    }
  },
  data() {
    return {
      active: this.activeDefault,
      visible: this.showDefault
    };
  },
  methods: {
    activate() {
      let wasActive = this.active;
      if (!this.multipleActive) {
        this.deactivateAll();
      }
      this.active = !wasActive;
      this.$emit('change', this.active)
    }
  },
  mounted() {
    this.addItem(this);
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    this.removeItem(this);
  }
};
</script>

<style scoped>

  .card-header:after {
    content: "\e6e1";
    font-family: element-icons!important;
    font-weight: 900;
    pointer-events: none;
  }
  .card-header, .card-header .card-title {
      cursor: auto;
  }
  .card-header .clickable {
      cursor: pointer;
      background-color: transparent;
      position: absolute;
      width: 100px;
      height: 65px;
      top: 0;
      left: 0;
  }
</style>
